import React, { useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const LineCharts = (props: any) => {
  const { data } = props;

  const [graphData, setGraphData] = React.useState([]);
  useEffect(() => {
    if (data) {
      setGraphData(data);
    }
  }, [data]);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        width={80}
        height={100}
        data={graphData}
        margin={{
          top: 5,
          right: 30,
          left: 5,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3" vertical={false} />
        <XAxis
          dataKey="date"
          padding={{ left: 4 }}
          style={{ marginBottom: "20px", marginTop: "20px" }}
        />
        <YAxis
          domain={["dataMin - 1", "dataMax + 1"]}
          type="number"
          tickFormatter={(value) => value.toFixed(3)}
          tickCount={10}
          padding={{ bottom: 10 }}
        ></YAxis>
        <Tooltip />
        <Line dataKey="rate" fill="#407BFF" stroke="#14B1E7" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default LineCharts;
